import React from 'react';
import { Grid, Typography } from '@mui/material';
import ResetPasswordForm from './ResetPasswordForm';
import { Link, useSearchParams } from 'react-router-dom';
import { useResize } from 'hooks/common';
import { useValidateToken } from 'hooks/auth';
import { SPARK_ROUTES } from 'constants/routes';
import MainAuthScreenWrapper from '../MainAuthScreenWrapper';
import { SparkImageLoader } from 'sharedComponents/UI';

function ResetPassword() {
  const { isMobile } = useResize();
  const [isValidToken, setIsValidToken] = React.useState(false);
  const {
    mutateAsync: validateToken,

    isLoading,
  } = useValidateToken();

  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const scoID = searchParams.get('sco_id');

  React.useEffect(() => {
    if (!token || !email || isValidToken) {
      return;
    }
    validateToken({ email: email, token }).then((res) => {
      if (res === 'Token is valid for the provided email.') {
        setIsValidToken(true);
      } else {
        setIsValidToken(false);
      }
    });
  }, [email, isValidToken, token, validateToken]);

  if (isLoading) {
    return (
      <Grid
        height='100vh'
        container
        justifyContent='center'
        alignItems='center'
      >
        <Typography color={(theme) => theme.palette.grey[800]}>
          Please Wait...
        </Typography>
      </Grid>
    );
  }

  return (
    <MainAuthScreenWrapper
      modalView
      gridContainerStyle={{ width: '80%', maxWidth: '600px !important' }}
    >
      <Grid
        item
        container
        flex={1}
        justifyContent='center'
        alignItems='center'
        height='100%'
      >
        <Grid
          container
          justifyContent='center'
          direction='column'
          paddingX={2}
          rowGap={4}
        >
          <Grid
            container
            rowGap={4}
            justifyContent='center'
            alignItems='center'
          >
            <a href='https://sparkup.ai/'>
              <SparkImageLoader
                src='SparkLogo.svg'
                alt='spark-logo'
                height={isMobile ? 46 : 58}
                width={435.18}
              />
            </a>
          </Grid>
          <Grid container direction='column' gap={2}>
            <Typography
              sx={{
                fontSize: '26px',
                fontFamily: 'Mont-semibold',
              }}
            >
              Reset Password
            </Typography>
            <Typography
              sx={{
                fontSize: '18px',
              }}
            >
              Reset your password to access your account
            </Typography>
          </Grid>
          <ResetPasswordForm />

          <Grid item container justifyContent='center'>
            <Link
              to={{
                pathname: SPARK_ROUTES.LOGIN,
                search: !!scoID ? `sco_id=${scoID}` : '',
              }}
              style={{ textDecoration: 'none' }}
            >
              <Typography
                style={{
                  textDecoration: 'none',
                  fontSize: '14px',
                  color: '#6267AC',
                }}
              >
                Login
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </MainAuthScreenWrapper>
  );
}

export default ResetPassword;
